import React, { useEffect, useState } from 'react';
import './ToastNotification.css';

interface ToastNotificationProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  duration?: number;
  onClose?: () => void;
}

export const ToastNotification: React.FC<ToastNotificationProps> = ({
  message,
  type = 'success',
  duration = 10000,
  onClose
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isLeaving, setIsLeaving] = useState(false);

  const handleClose = () => {
    setIsLeaving(true);
    setTimeout(() => {
      setIsVisible(false);
      onClose?.();
    }, 300); // Match animation duration
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  if (!isVisible) return null;

  return (
    <div 
      className={`ibl-custom-notification ibl-custom-notification-${type} ${
        isLeaving ? 'ibl-custom-notification-leaving' : ''
      }`}
      style={{
        animation: isLeaving 
          ? 'ibl-custom-notification-slide-out 0.3s ease-out'
          : 'ibl-custom-notification-slide-in 0.3s ease-out'
      }}
    >
      <div className="ibl-custom-notification-content">
        <span className="ibl-custom-notification-message">{message}</span>
        <button 
          className="ibl-custom-notification-close"
          onClick={handleClose}
        >
          ×
        </button>
      </div>
    </div>
  );
}; 